import { render, staticRenderFns } from "./CompositeObjectsSelector.vue?vue&type=template&id=2797212a&"
import script from "./CompositeObjectsSelector.vue?vue&type=script&lang=js&"
export * from "./CompositeObjectsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports